/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateDocumentFolderResponseData,
  CreateDocumentFolderResponseDataFromJSON,
  CreateDocumentFolderResponseDataFromJSONTyped,
  CreateDocumentFolderResponseDataToJSON
} from './CreateDocumentFolderResponseData'

/**
 *
 * @export
 * @interface UpdateDocumentFolderResponse
 */
export interface UpdateDocumentFolderResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateDocumentFolderResponse
   */
  status?: number
  /**
   *
   * @type {CreateDocumentFolderResponseData}
   * @memberof UpdateDocumentFolderResponse
   */
  data?: CreateDocumentFolderResponseData
}

export function UpdateDocumentFolderResponseFromJSON(json: any): UpdateDocumentFolderResponse {
  return UpdateDocumentFolderResponseFromJSONTyped(json, false)
}

export function UpdateDocumentFolderResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateDocumentFolderResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateDocumentFolderResponseDataFromJSON(json['data'])
  }
}

export function UpdateDocumentFolderResponseToJSON(value?: UpdateDocumentFolderResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateDocumentFolderResponseDataToJSON(value.data)
  }
}
